import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const MASKED_TEXT = '********';

export const hasMaskableValue = value => value !== undefined && value !== null && value !== '';

export const RevealButton = ({label, revealed, onToggle}) => (
    <IconButton
        size="small"
        aria-label={`${revealed ? 'Hide' : 'Show'} ${label}`}
        onClick={onToggle}
        sx={{p: 0.25}}
    >
        {revealed ? <VisibilityOffIcon fontSize="small"/> : <VisibilityIcon fontSize="small"/>}
    </IconButton>
);

RevealButton.propTypes = {
    label: PropTypes.string.isRequired,
    revealed: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired
};

const MaskedValue = ({value, label}) => {
    const [revealedValue, setRevealedValue] = useState(null);
    const revealed = hasMaskableValue(value) && revealedValue === value;

    if (!hasMaskableValue(value)) {
        return null;
    }

    return (
        <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', columnGap: 0.5, whiteSpace: 'nowrap'}}>
            <span>{revealed ? value : MASKED_TEXT}</span>
            <RevealButton label={label} revealed={revealed} onToggle={() => setRevealedValue(revealed ? null : value)}/>
        </Box>
    );
};

MaskedValue.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string.isRequired
};

export default MaskedValue;
